import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgentInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/agent-invoice",
            component: () => loadView(import("./AgentInvoiceTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/agent-invoice/detail/:id",
            component: () => loadView(import("./AgentInvoiceDetail.vue")),
        },
        build(id: string) {
            return `/agent-invoice/detail/${id}`;
        },
    },
});
